// Module
var code = "<span>No results</span>";
// Exports
export default code;